import React, { Component } from 'react';
import lang from '../../../lang/index';
import Popup from '../../../popup/common-popup';
import ConfirmForm from './confirm-form';
import ConfirmSuccess from './confirm-success';
import './confirm.css';

export default class PaystackConfirmModal extends Component {
    constructor(props){
        super(props);
        this.state = {
            confirmed: false
        };
    }

    componentDidMount() {
        const self = this;
        const ctx = {
            closeOnClick: false,
            keyboard: false
        };
        Popup.create(ctx, ConfirmForm, function(ret, extra) {
            if (ret === 'confirm') {
                self.props.onCompleted(extra);
                // this.setState({ confirmed : true });
                // Popup.create(ctx, ConfirmSuccess, function(conf) {
                //     if (conf === 'confirm') {
                //         self.props.onCompleted(extra);
                //     }
                // });
            }
        });
    }

    render() {
        return (<div></div>);
    }
}



// WEBPACK FOOTER //
// ./js/orderview/channels/paystack/confirm-modal.js